<template>
  <div class="block-g">
    <div class="block-g__block">
      <div class="block-g__block-line">
        <div class="block-g__title">Грузчик</div>
        <div class="block-g__content">
          <div class="block-g__image desktop">
            <img src="../assets/img/block-g-1.jpg" alt="">
          </div>
          <div class="block-g__image mobile">
            <img src="../assets/img/block-g-1-m.jpg" alt="">
          </div>
          <div class="block-g__letter letter letter-red">
            Г.
          </div>
          <div class="block-g__text text text-black">
            <p>Куда устроиться на работу, если ты сразу и красивый, <br>и русский? Можно продавать открытки. Или корпеть дни напролёт в изматывающем поиске ошибок в типографии. Ещё играть в любительских спектаклях. А можно устроиться на работу мечты — бухгалтером в гостиницу «Европейская», ведь если найдёшь себе профессию по душе — работать не придётся ни дня.</p>
            <p>Всё это Вертинский успел перепробовать на заре своей карьеры. Самый богемный бухгалтер «века джаза» был уволен через короткое время за «неспособность». <br>Что остаётся делать, если опережаешь время и твои новаторские методы пока не могут оценить по достоинству? Правильно, подработать грузчиком. <br>Как грузчик Александр Вертинский оказался гораздо востребованнее.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockG'
}
</script>

<style lang="sass">
  .mobile
    display: none
    @media screen and (max-width: 999px)
      display: block
  .desktop
    display: block
    @media screen and (max-width: 999px)
      display: none
  .block-g
    position: relative
    z-index: 300
    padding-bottom: vw(92px)
    &__block
      background-color: #fff
      width: vw(1168px)
      margin: auto
      padding: vw(6px) vw(7px)
      @media screen and (max-width: 999px)
        width: 100vw
        margin-top: vwm(67px)
        padding: vwm(8px)
      &-line
        border: 1px solid #000000
        padding-top: vw(38px)
        padding-left: vw(52px)
        padding-right: vw(31px)
        padding-bottom: vw(25px)
        @media screen and (max-width: 999px)
          padding: vwm(8px)
    &__image
      width: vw(377px)
      min-width: vw(377px)
      margin-top: vw(-80px)
      position: relative
      @media screen and (max-width: 999px)
        width: 100vw
        margin-left: vwm(-17px)
        margin-top: vwm(22px)
      &:before
        @media screen and (max-width: 999px)
          content: ''
          display: block
          width: 1px
          height: 37vw
          background-color: #000
          position: absolute
          right: vwm(8px)
          z-index: 20
          top: vwm(-29px)
      &:after
        content: ''
        width: 0
        height: 0
        border-style: solid
        border-width: 0 vw(158px) vw(158px) 0
        border-color: transparent #ffffff transparent transparent
        position: absolute
        top: vw(-23px)
        right: vw(-13px)
        @media screen and (max-width: 999px)
          border-width: 0 vwm(158px) vwm(158px) 0
          top: vwm(-29px)
          right: vwm(-20px)
      img
        width: 100%
    &__title
      font-size: vw(72px)
      font-family: 'ZnikomitNo25'
      color: #000
      text-align: center
      margin-left: vw(-21px)
      @media screen and (max-width: 999px)
        font-size: vwm(60px)
        margin-left: 0
        margin-top: vwm(11px)
    &__content
      display: flex
      @media screen and (max-width: 999px)
        flex-direction: column
    &__letter
      margin-left: vw(-87px)
      margin-top: vw(62px)
      padding-left: vw(27px)
      @media screen and (max-width: 999px)
        margin-left: vwm(159px)
        margin-top: vwm(-129px)
        padding-left: vwm(17px)
    &__text
      margin-left: vw(81px)
      margin-top: vw(44px)
      @media screen and (max-width: 999px)
        margin-left: vwm(13px)
        margin-top: vwm(61px)
        line-height: vwm(22px)
        width: 84vw
        br
          display: none
        p
          margin-bottom: vwm(76px)
          position: relative
          &:after
            content: ''
            display: block
            width: vwm(207px)
            height: 1px
            background-color: #000
            position: absolute
            left: 0
            right: 0
            margin: auto
            bottom: vwm(-40px)
          &:last-child
            margin-bottom: vwm(34px)
            &:after
              display: none
</style>
